module.exports = "https://www.gc-qa.gnp.com.mx/94518663537f2a4ac2fb18b9e427f90e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/acceso-familiar-icon.svg
// module id = 934
// module chunks = 0